import Reveal from "@/components/base/Reveal";

interface Campaign {
  name: string;
  cost: string;
  conv: string;
  cpa: string;
  status: string;
  budget: string;
  bidStrategy: string;
  type: string;
  highlight?: boolean;
}

const campaigns: Campaign[] = [
  { name: "OPERAÇÃO CPA 11/05", cost: "R$ 6.777,43", conv: "5.276", cpa: "R$ 1,28", status: "Inactive", budget: "No Limit", bidStrategy: "Cost Cap", type: "Website" },
  { name: "G10 - 23/05", cost: "R$ 3.467,59", conv: "2.643", cpa: "R$ 1,31", status: "Inactive", budget: "2.556,00", bidStrategy: "Cost Cap", type: "Website", highlight: true },
  { name: "ODD 27", cost: "R$ 3.018,80", conv: "3.317", cpa: "R$ 0,91", status: "Inactive", budget: "750,00", bidStrategy: "Cost Cap", type: "Website" },
  { name: "G10 - 16/04", cost: "R$ 2.459,60", conv: "2.170", cpa: "R$ 1,13", status: "Inactive", budget: "No Limit", bidStrategy: "Cost Cap", type: "Website" },
  { name: "21/06", cost: "R$ 2.254,34", conv: "1.247", cpa: "R$ 1,81", status: "Inactive", budget: "No Limit", bidStrategy: "Cost Cap", type: "Website" },
  { name: "G10 - 28/05", cost: "R$ 2.209,84", conv: "1.692", cpa: "R$ 1,31", status: "Inactive", budget: "797,00", bidStrategy: "Cost Cap", type: "Website" },
  { name: "G10 - 26/05", cost: "R$ 2.015,15", conv: "1.411", cpa: "R$ 1,43", status: "Inactive", budget: "797,00", bidStrategy: "Cost Cap", type: "Website" },
  { name: "G10 - 05/05-06/05", cost: "R$ 1.986,46", conv: "1.493", cpa: "R$ 1,33", status: "Inactive", budget: "1.556,00", bidStrategy: "Cost Cap", type: "Website" },
];

const totals = {
  cost: "R$ 139.707,33",
  conv: "98.021",
  cpa: "R$ 1,43",
};

export default function CampaignsShowcase() {
  return null;
}